const ADMIN_NOTIFICATION_TARGETS: Record<string, string> = {
  '/me/attendance-approvals': '/attendance/approvals',
  '/me/approvals': '/processes/requests/pending',
};

/** Translate worker-portal notification links for the admin shell. */
export function adminNotificationTarget(link: string): string {
  const [path, suffix = ''] = link.split(/([?#].*)/, 2);
  const target = ADMIN_NOTIFICATION_TARGETS[path];
  if (target) return `${target}${suffix}`;
  const requestMatch = path.match(/^\/me\/requests\/([^/]+)$/);
  if (requestMatch) {
    const openId = encodeURIComponent(requestMatch[1]);
    if (suffix.startsWith('?')) {
      return `/processes/requests/history?openId=${openId}&${suffix.slice(1)}`;
    }
    return `/processes/requests/history?openId=${openId}${suffix}`;
  }
  return link;
}
